import React from 'react'
import { Outlet } from 'react-router-dom'
import SideBar from '../SideBar/SideBar';

const MainPage = () => {
    return (
        <>
            <section>

                <SideBar />
                <main className='main-section'>
                    {/* <Homepage /> */}
                    <Outlet />
                    {/* <ChatPage /> */}

                </main>


            </section>
        </>
    )
}

export default MainPage